/* unplugin-vue-components disabled */import script from "./announcementCarousel.vue?vue&type=script&lang=js"
export * from "./announcementCarousel.vue?vue&type=script&lang=js"

import "./announcementCarousel.vue?vue&type=style&index=0&id=3c6fc38b&lang=scss"

const __exports__ = script;

export default __exports__